(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fadeCaption(elements, callback) {
    if (!elements.length || prefersReducedMotion) {
      if (callback) callback();
      return;
    }

    elements.forEach(function (el) {
      el.classList.add('is-fading');
    });

    window.setTimeout(function () {
      if (callback) callback();
      elements.forEach(function (el) {
        el.classList.remove('is-fading');
      });
    }, 150);
  }

  function initSourcing(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var cards = root.querySelectorAll('[data-erk-src-card]');
    var images = root.querySelectorAll('[data-erk-src-image]');
    var title = root.querySelector('[data-erk-src-title]');
    var text = root.querySelector('[data-erk-src-text]');

    function activate(index) {
      if (!cards.length) return;
      var card = cards[index];
      var id = card.dataset.erkSrcCard;

      cards.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
        item.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });

      images.forEach(function (image) {
        image.classList.toggle('is-active', image.dataset.erkSrcImage === id);
      });

      var captionEls = [title, text].filter(Boolean);
      fadeCaption(captionEls, function () {
        if (title) title.textContent = card.dataset.erkSrcTitle || '';
        if (text) text.textContent = card.dataset.erkSrcText || '';
      });
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        activate(index);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-erk-sourcing]').forEach(initSourcing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-erk-sourcing]');
    if (root) initSourcing(root);
  });
})();
